import * as _ from 'lodash';
import { ResponsibleFinancial } from './project/ResponsibleFinancial.model';
import { CertificateType } from '../shared/enums/CertificateType'

export class LegalCertificate {
    _id: string;
    name: string;
    type: CertificateType;
    observation: string;
    owner: ResponsibleFinancial = new ResponsibleFinancial();
    notificationsDays: Number = 30
    skills: any[];
    position: string;
    created: Date;
    changed: Date;
    renovationDate: string;
    totalValue: number = 0;

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }

    loadCertificateFromServer(c: any) {
        if(c._id !== undefined)
            this._id = c._id
        if(c.name !== undefined)
            this.name = c.name
        if(c.type !== undefined)
            this.type = c.type;
        if(c.observation !== undefined)
            this.observation = c.observation;
        if(c.renovationDate !== undefined)
            this.renovationDate = c.renovationDate;
        if(c.owner !== undefined)
            this.owner = c.owner;
        if (c.totalValue !== undefined)
            this.totalValue = c.totalValue;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/legalCertificate.model.ts